import { DOCS, RISE_TESTNET_EXPLORER } from "@/lib/url";

export type NavigationItem = {
  id: string;
  label: string;
  path: string;
  isDisabled: boolean;
  icon?: string;
};

export type Navigation = NavigationItem & {
  subMenu?: NavigationItem[];
};

export function useNavigation() {
  const navItems: Navigation[] = [];

  const toolbarItems: Navigation[] = [
    {
      id: "explorer",
      label: "Explorer",
      path: RISE_TESTNET_EXPLORER,
      isDisabled: false,
    },
    {
      id: "dics",
      label: "Docs",
      path: DOCS,
      isDisabled: false,
    },
  ];

  const footerItems: Navigation[] = [];

  return { navItems, footerItems, toolbarItems };
}
